import React, { useState, useEffect, useRef } from 'react';
//import {Link} from 'react-router-dom';
import { connect } from 'react-redux';
//import Table from 'react-bootstrap/Table';
import Card from 'react-bootstrap/Card';
import Nav from 'react-bootstrap/Nav';

import UserDataService from '../services/user-activities';
import { withRouter } from 'react-router';

//import { TOTAL_TICKET_COUNT, OPEN_TICKET_COUNT } from '../features/actions/Is-Logged-Actions';

import { Redirect } from 'react-router';

import Container from 'react-bootstrap/Container';
import {
    Table,
    ScrollArea,
    UnstyledButton,
    Group,
    Grid,
    Text,
    Center,
    TextInput,
    rem,
    keys,
    Button,
    Paper,
    Pill,
    Select,
    Checkbox,
    Switch,
    Tooltip,
    Flex,
    Modal
} from '@mantine/core';

import Navbar from './Navbar';

import { useSelector, useDispatch } from 'react-redux';

import SoftwareAssetDataService from '../services/software-asset-activities';
import ProjectDataService from '../services/project-activities';

import { useHistory } from 'react-router-dom';
import { DateTimePicker } from '@mantine/dates';

import dayjs from 'dayjs';

//import { LOGOUT } from '../features/actions/Is-Logged-Actions';

export default function ViewProjects({LOGOUT, onLogout}) {

    const history = useHistory();

    const loggedStatus = useSelector(state => state.logged);

    const [customerId, setCustomerId] = useState(0);
    const [customerName, setCustomerName] = useState("All");
    const [customers, setCustomers] = useState(null);

    const [projects, setProjects] = useState(null);

    const [ignoreDate, setIgnoreDate] = useState(true);
    const [updatedFrom, setUpdatedFrom] = useState("");
    const [updatedTo, setUpdatedTo] = useState("");


    function convertDateToMySQL(date) {
        try {
            const mysqlFormat = dayjs(date).format('YYYY-MM-DD HH:mm:ss');
            return mysqlFormat;
        }

        catch {
            return "";
        }
    }

    async function getProjects() {
        return new Promise(async (resolve, reject) => {
            let updatedFromToUse;
            let updatedToToUse;

            if(updatedFrom === null || updatedFrom === "") {
                updatedFromToUse = "";
            }

            else {
                updatedFromToUse = convertDateToMySQL(updatedFrom);
            }

            if(updatedTo === null || updatedTo === "") {
                updatedToToUse = "";
            }

            else {
                updatedToToUse = convertDateToMySQL(updatedTo);
            }

            // this version of getProjects comes from filter changing and is for the front end - thus generate_report is false
            ProjectDataService.getProjects(loggedStatus.primary_tenant_id, customerId, ignoreDate, updatedFromToUse, updatedToToUse, false).then(response => {
                console.log("Response from get projects: ", response);
                resolve(response.data.results);
            })
            .catch(e => {
                console.error(e);
                reject(e);
            });

        });
    }

    // this function is very similar to getProjects, but it instead gives the endpoint a generate_report value of true
    async function generateReport() {
        return new Promise(async (resolve, reject) => {
            let updatedFromToUse;
            let updatedToToUse;

            if(updatedFrom === null || updatedFrom === "") {
                updatedFromToUse = "";
            }

            else {
                updatedFromToUse = convertDateToMySQL(updatedFrom);
            }

            if(updatedTo === null || updatedTo === "") {
                updatedToToUse = "";
            }

            else {
                updatedToToUse = convertDateToMySQL(updatedTo);
            }

            // this version of getProjects comes from filter changing and is for the front end - thus generate_report is false
            ProjectDataService.generateReport(loggedStatus.primary_tenant_id, customerId, ignoreDate, updatedFromToUse, updatedToToUse, true).then(async response => {
                //console.log("Response from get projects - report version: ", response);

                const blob = new Blob([response.data], {type: 'application/pdf'});

                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Project_Report.pdf');
                document.body.appendChild(link);
                link.click();

                link.remove();
                window.URL.revokeObjectURL(url);

                resolve("Report generated!");
            })
            .catch(e => {
                console.error(e);
                reject(e);
            });

        });
    }

    const getCustomerId = (nameToFind) => {
        const customer = customers.find(customer => customer.name === nameToFind);
        return customer ? customer.id : null; 
    };

    async function handleCustomerChange(newName) {
        let customerId = getCustomerId(newName);
        setCustomerId(customerId);
        setCustomerName(newName);

        //let projects = await getProjects();

        //setProjects(projects);
    }

    function mysqlDateTimeToDate(mysqlDateTime) {
        // "2026-01-27 12:58:00"
        const [datePart, timePart] = mysqlDateTime.split(" ");
        const [year, month, day] = datePart.split("-").map(Number);
        const [hour, minute, second] = timePart.split(":").map(Number);
      
        // month is 0-based in JS Date 
        const formattedDate = new Intl.DateTimeFormat('en-US', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        }).format(new Date(year, month - 1, day, hour, minute, second));

        return formattedDate;
    }

    useEffect(() => {
        const loadData = async () => {
            //console.log("Value for loggedStatus: ", loggedStatus);
            SoftwareAssetDataService.getCustomers(loggedStatus.primary_tenant_id).then(async response => {
                console.log(response);
                setCustomers([{id: 0, name: "All"}, ...response.data.results]);

                let projectList = await getProjects();

                setProjects(projectList);

                console.log("Project info returned: ", projectList);
            });
        }

        loadData();
    }, []);


    // when the customer id has finished changing, re-fetch the projects
    useEffect(() => {
        const fetchProjects = async () => {
            if(ignoreDate === true || (updatedFrom !== null && updatedFrom !== "" && updatedTo !== null && updatedTo !== "")) {
                console.log("Fetch projects triggered");
                let projectList = await getProjects();
                setProjects(projectList);
            }
        }

        fetchProjects();
    }, [customerId, ignoreDate, updatedFrom, updatedTo]);


    function goToSpecificProject(id) {
        history.push(`/editProject/${id}`);
    }


    if (!loggedStatus.loggedIn) {
            return (
                <Redirect to='/' />
            );
    }

    return (
        <>
            <Navbar pageTitle={"Projects"} />
            <div className="container mt-3" style={{ paddingTop: "15px" }}></div>
            <Container fluid pt="20px" >
                <Paper withBorder p="md" radius="md" w="100%" mb="sm" display="inline-block">
                    <div style={{ display: "flex", alignItems: "flex-end" }}>
                        <span style={{ /* display: "inline-block", */ width: "31%" }}>
                            <Select 
                                label="Customer"
                                placeholder="Pick value"
                                data={
                                    customers && customers.map((customer) => (
                                        // {value: customer.id.toString(), label: customer.name}
                                        customer.name
                                    ))
                                }
                                value={customerName}
                                onChange={(e) => handleCustomerChange(e)}
                            />
                        </span>
                        <span style={{marginLeft: "25px"}}>
                            <Checkbox 
                                label="Ignore Date"
                                checked={ignoreDate}
                                onChange={(event) => setIgnoreDate(event.currentTarget.checked)}
                            />
                        </span>
                        {ignoreDate === false &&
                            <span style={{marginLeft: "25px"}}>
                                <DateTimePicker 
                                    label="Last Updated - From"
                                    placeholder="Pick date and time"
                                    valueFormat={"MM / DD / YYYY hh:mm A"}
                                    value={updatedFrom && updatedFrom !== null ? updatedFrom : ""}
                                    onChange={setUpdatedFrom}
                                    clearable
                                />
                            </span>
                        }
                        {ignoreDate === false &&
                            <span style={{marginLeft: "25px"}}>
                                <DateTimePicker
                                    label="Last Update - To"
                                    placeholder="Pick date and time"
                                    valueFormat={"MM / DD / YYYY hh:mm A"}
                                    value={updatedTo && updatedTo !== null ? updatedTo : ""}
                                    onChange={setUpdatedTo}
                                    clearable
                                />
                            </span>
                        }
                        <span style={{marginLeft: "25px"}}>
                            {ignoreDate === true || (updatedTo !== "" && updatedTo !== null && updatedFrom !== "" && updatedFrom !== null) ?
                                <Button color="teal" onClick={() => generateReport()}>Generate Report</Button>
                                :
                                <Tooltip label="Either ignore dates or input both to and from"><Button color="teal" disabled>Generate Report</Button></Tooltip>
                            }
                        </span>
                        <span style={{ marginLeft: "auto" }}>
                            <Button onClick={() => history.push('/addProject')}>+ Add Project</Button>
                        </span>
                    </div>
                    {/* <span style={{ display: "inline-block", paddingLeft: "5px", cursor: "pointer" }}>
                            <Tooltip label="Click to create a new customer"><IconPlus color="#00abfb" onClick={() => this.openCustomerModal()} /></Tooltip>
                    </span> */}
                </Paper>
                <Paper withBorder p="md" radius="md" w="100%" mb="sm" display="inline-block">
                    <Table miw={700} highlightOnHover>
                        <Table.Thead>
                            <Table.Tr>
                                <Table.Td style={{width: "5%"}}>Company</Table.Td>
                                <Table.Td style={{width: "14%"}}>Project Title</Table.Td>
                                <Table.Td style={{width: "15%"}}>Project Team</Table.Td>
                                <Table.Td style={{width: "15%"}}>Description</Table.Td>
                                <Table.Td style={{width: "15%"}}>Current Task</Table.Td>
                                <Table.Td style={{width: "15%"}}>Next Steps</Table.Td>
                                <Table.Td style={{width: "10%"}}>Currently Assigned To</Table.Td>
                                <Table.Td style={{width: "6%"}}>Status</Table.Td>
                                <Table.Td style={{width: "5%"}}>Last Updated</Table.Td>
                            </Table.Tr>
                        </Table.Thead>
                        <Table.Tbody>
                            {projects && projects.map((project) => (
                                <Table.Tr style={{cursor: "pointer"}} onClick={() => goToSpecificProject(project.id)} key={`project-${project.id}`}>
                                    <Table.Td>{project.customer_name}</Table.Td>
                                    <Table.Td>{project.title}</Table.Td>
                                    <Table.Td>{project.team_members}</Table.Td>
                                    <Table.Td>{project.description}</Table.Td>
                                    <Table.Td>{project.current_task}</Table.Td>
                                    <Table.Td>{project.next_steps}</Table.Td>
                                    <Table.Td>{project.currently_assigned_to}</Table.Td>
                                    <Table.Td>{project.status}</Table.Td>
                                    <Table.Td>{project.last_update !== null && project.last_update !== "" ? <div><div>{mysqlDateTimeToDate(project.last_update).split(", ")[0]}</div><div>{mysqlDateTimeToDate(project.last_update).split(", ")[1]}</div></div> : ""}</Table.Td>
                                </Table.Tr>
                            ))}
                        </Table.Tbody>
                    </Table>
                </Paper>
            </Container>
        </>
    );
}